<template>
  <CModal
    :title="
      challengeId && challenge.Id ? 'Update Challenge' : 'Create Challenge'
    "
    :show.sync="detailModal"
    :closeOnBackdrop="false"
    color="warning"
    centered
    size="lg"
  >
    <template v-slot:body-wrapper>
      <div
        class="modal-body overflow-auto"
        style="max-height: calc(100vh - 11.6rem)"
      >
        <div class="row">
          <div class="col-md-3">
            <CSelect
              label="Topic*"
              placeholder="Select Topic"
              :value.sync="challenge.AreaId"
              :options="[
                { value: null, label: '---Select Topic---' },
                ...areas,
              ]"
              :add-input-classes="{
                'is-invalid': !!inValidObject['challenge.AreaId'],
              }"
              :invalid-feedback="inValidObject['challenge.AreaId']"
            />
          </div>
          <div class="col-md-7">
            <CInput
              label="Title*"
              placeholder="Title"
              v-model="challenge.Title"
              :add-input-classes="{
                'is-invalid': !!inValidObject['challenge.Title'],
              }"
              :invalid-feedback="inValidObject['challenge.Title']"
              :description="similarText ? `${similarText}!!!` : ''"
            />
          </div>
          <div class="col-md-2">
            <div role="group" class="form-group text-center">
              <label> Anonymous </label>
              <div class="py-2">
                <CSwitch
                  :checked.sync="challenge.IsAnonymous"
                  shape="pill"
                  variant="opposite"
                  size="sm"
                  color="info"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <CTextarea
              ref="txtDescription"
              rows="5"
              class="mb-2"
              label="Description*"
              placeholder="Description"
              v-model="challenge.Description"
              :add-input-classes="{
                'is-invalid': !!inValidObject['challenge.Description'],
              }"
              :invalid-feedback="inValidObject['challenge.Description']"
            />
            <div v-if="hashtags && hashtags.length" class="form-row mb-4">
              <div
                v-for="(tag, i) in hashtags"
                :key="`tag-${i}`"
                class="col-auto"
              >
                <a href="javascript:" @click="addTag(tag)">
                  <span class="badge badge-light">
                    {{ tag }}
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group form-row">
              <label class="col-md-3">
                Attachment <br />
                <span class="small">
                  <strong>(jpg, png, pdf, xlsx, xls, docx, doc)</strong>
                </span>
              </label>
              <div class="col-md-9">
                <div class="form-row">
                  <div class="col-12">
                    <input
                      class="form-control"
                      type="file"
                      ref="fileAttachment"
                      accept=".jpg,.png,.pdf,.xlsx,.xls,.docx,.doc"
                      @change="(e) => fileUploadChange(e)"
                    />
                  </div>
                  <!-- <div class="col-2">
                    <button
                      type="button"
                      class="btn btn-success px-0 w-100"
                      @click="addFile"
                    >
                      Add file
                    </button>
                  </div> -->
                </div>
                <div class="invalid-feedback">
                  {{ inValidObject["AttachedFiles"] }}
                </div>
                <div
                  v-if="showingAttachments && showingAttachments.length"
                  class="mt-3"
                >
                  <div
                    class="mb-1 form-row"
                    v-for="attach in showingAttachments"
                    :key="`attachment-${attach.id}`"
                  >
                    <div class="col-11">
                      <i :class="`fas ${getIcon(attach.fileName)}`"></i>
                      {{ attach.fileName }}
                    </div>
                    <div class="col-1">
                      <a
                        class="text-danger"
                        href="javascript:"
                        :title="`Remove '${attach.fileName}'`"
                        @click="removeFile(attach)"
                      >
                        <i class="fas fa-trash"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <similarItem
            :title="challenge.Title"
            @updateText="(e) => (similarText = e)"
          />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <CButton
        class="btn btn-primary"
        @click="saveChallenge"
        :disabled="saving"
      >
        <i class="fas fa-save"></i>
        Save challenge
      </CButton>
      <div class="d-inline-block font-italic" v-if="saving">
        <CSpinner color="info" size="sm" class="ml-2" />
        Updating...
      </div>
    </template>
  </CModal>
</template>

<script>
import similarItem from "./Similar.vue";

export default {
  props: ["editing", "challengeId"],
  components: {
    similarItem,
  },
  data() {
    return {
      detailModal: false,
      inValidObject: {},
      challenge: this.newChallenge(),
      saving: false,
      areas: [],
      attachments: [],
      hashtags: [],
      similarText: null,
    };
  },
  mounted() {
    this.getAreas();
    this.getHashTag();
  },
  computed: {
    showingAttachments() {
      let attachments = this.attachments;
      return attachments
        .map((_) => {
          return {
            id: _.id,
            fileName: _.fileName,
            isDeleted: _.isDeleted,
          };
        })
        .filter((_) => !_.isDeleted);
    },
  },
  watch: {
    async challengeId(val) {
      await this.loadChallengeInfo(val);
    },
    editing(val) {
      this.detailModal = val;
      if (!val) {
        this.$emit("update:challengeId", null);
      }
    },
    detailModal(val) {
      this.$emit("update:editing", val);
    },
  },
  methods: {
    newChallenge() {
      this.attachments = [];
      return {
        Id: 0,
        Title: null,
        Description: null,
        AreaId: null,
        IsAnonymous: false,
      };
    },
    async getAreas() {
      let result = [];
      let resp = await this.$http.get("/odata/SipArea", {
        params: {
          $select: "Id,Name",
          $filter: `Status eq ${this.$const.STATUS.Active}`,
          $orderby: `DisplayOrder asc`,
        },
      });
      if (resp && resp.status == 200 && resp.data.value.length) {
        result = resp.data.value.map((_) => {
          return {
            value: _.Id,
            label: _.Name,
          };
        });
      }
      this.areas = result;
    },

    async getHashTag() {
      let result = [];
      let resp = await this.$http.get("/SipFile/get-hash-tags");
      if (
        resp &&
        resp.status == 200 &&
        resp.data &&
        resp.data.status == this.$const.RESPONSE_TYPES.Success
      ) {
        result = resp.data.data.map((_) => {
          return _.value;
        });
      }
      this.hashtags = result;
    },

    fileUploadChange(e) {
      //this.attachment = e.target.files;
      if (e.target.files && e.target.files.length) {
        for (let i = 0; i < e.target.files.length; i++) {
          let file = e.target.files[i];
          this.attachments.push({
            id: new Date().getTime() + i,
            fileName: file.name,
            file,
            isDeleted: false,
          });
        }
        this.$refs["fileAttachment"].value = null;
      }
    },

    removeFile(attach) {
      let id = attach.id;
      if (this.attachments && this.attachments.length) {
        this.attachments.forEach((_) => {
          if (_.id == id) {
            _.isDeleted = true;
          }
        });
      }
    },

    toBase64(file) {
      return URL.createObjectURL(file);
    },

    getIcon(fileName) {
      let _ = fileName;
      return _.endsWith(".png") || _.endsWith(".jpg")
        ? "fa-image"
        : _.endsWith(".xlsx") || _.endsWith(".xls")
        ? "fa-file-excel"
        : _.endsWith(".docx") || _.endsWith(".doc")
        ? "fa-file-word"
        : _.endsWith(".pdf")
        ? "fa-file-pdf"
        : "fa-file";
    },

    async loadChallengeInfo(challengeId) {
      try {
        this.inValidObject = {};
        this.attachments = [];
        if (challengeId) {
          let filters = [];
          challengeId && filters.push(`Id eq ${challengeId}`);
          filters.push(
            `(Status eq ${this.$const.CHALLENGE_STATUS.New} or Status eq ${this.$const.CHALLENGE_STATUS.NeedsInfo})`
          );

          let resp = await this.$http.get(`odata/SipChallenge`, {
            params: {
              $top: 1,
              $filter: filters.join(" and "),
              $select: "Id,Title,Description,AreaId,AttachedFiles,IsAnonymous",
            },
          });
          if (resp && resp.status == 200) {
            let _ = resp.data.value[0];
            this.challenge = {
              Id: _.Id,
              Title: _.Title,
              Description: _.Description,
              AreaId: _.AreaId,
              IsAnonymous: _.IsAnonymous,
            };
            if (_.AttachedFiles) {
              this.attachments = JSON.parse(_.AttachedFiles).map((f, i) => {
                return {
                  id: new Date().getTime() + i,
                  fileName: f,
                  file: null,
                  isDeleted: false,
                };
              });
            }
          }
        } else {
          this.challenge = this.newChallenge();
        }
      } catch (error) {
        alert(error);
      }
    },

    async saveChallenge() {
      let challenge = this.challenge;
      this.inValidObject = this.checkValid(challenge);
      if (Object.keys(this.inValidObject).length) {
        alert("The information is not finished. Please check again!");
        return;
      }

      this.saving = true;
      try {
        let attachedFiles = this.attachments
          .filter((_) => !_.isDeleted)
          .map((_) => _.fileName);
        let challengeData = {
          Title: challenge.Title,
          AreaId: challenge.AreaId,
          Description: challenge.Description,
          AttachedFiles:
            attachedFiles && attachedFiles.length
              ? JSON.stringify(attachedFiles)
              : null,
          IsAnonymous: challenge.IsAnonymous,
        };
        // Challenge
        if (!challenge.Id) {
          // post
          let resp = await this.$http.post(`odata/SipChallenge`, challengeData);
          if (resp && resp.status == 201) {
            await this.uploadFile(resp.data.Id);
            this.detailModal = false;
            this.$emit("reload", 0);
          }
        } else {
          // patch
          let resp = await this.$http.patch(
            `odata/SipChallenge/${challenge.Id}`,
            challengeData
          );
          if (resp && resp.status == 204) {
            await this.uploadFile(challenge.Id);
            this.detailModal = false;
            this.$emit("reload", challenge.Id);
          }
        }
      } catch (error) {
        alert(error);
      }
      this.saving = false;
    },

    async uploadFile(challengeId) {
      // Kiem tra lai (deleted files)
      if (this.attachments && this.attachments.length) {
        let frmData = new FormData();
        frmData.append("Id", challengeId);
        frmData.append("IsReplaced", false);
        frmData.append("EntityName", "SipChallenge");

        let deletedNames = [];
        this.attachments.forEach((attach) => {
          if (attach.isDeleted && !attach.file) {
            deletedNames.push(attach.fileName);
          }
          if (!attach.isDeleted && attach.file) {
            frmData.append(`Files`, attach.file);
          }
        });
        if (deletedNames && deletedNames.length) {
          frmData.append("DeletedNames", JSON.stringify(deletedNames));
        }

        if (frmData.has("Files") || frmData.has("DeletedNames")) {
          await this.$http.post("/SipFile", frmData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        }
      }
    },

    checkValid(challenge) {
      let inValidObject = {};

      if (!challenge.AreaId)
        inValidObject["challenge.AreaId"] = "Topic is required";
      if (!challenge.Title)
        inValidObject["challenge.Title"] = "Title is required";
      if (!challenge.Description)
        inValidObject["challenge.Description"] = "Description is required";

      return inValidObject;
    },

    addTag(tag) {
      let textarea =
        this.$refs.txtDescription.$el.getElementsByTagName("textarea")[0];
      let value = textarea.value ?? "";
      let start_position = textarea.selectionStart;
      let end_position = textarea.selectionEnd;
      if (end_position) {
        this.challenge.Description = `${value.substring(
          0,
          start_position
        )} ${tag} ${value.substring(end_position, value.length)}`;
      } else {
        this.challenge.Description = `${value} ${tag}`;
      }
    },
  },
};
</script>
